import React, { useContext, useEffect, useState } from "react"
import CustomerContext from "../../../context/CustomerProvider"
import AddressTab from "./AddressTab"
import OrdersTab from "./OrdersTab"
import SettingsTab from "./SettingsTab"

const Account = () => {
  const value = useContext(CustomerContext)
  // const signoutCustomer = value?.signoutCustomer

  const [activeTab, setActiveTab] = useState(0)
  const [isLoading, setLoading] = useState(true)

  const [orders, setOrders] = useState([])

  const [orderPage, setPage] = useState(1)
  const [isLoadMore, setIsLoadMore] = useState(false)

  // console.log({ isLoading, orders, orderPage, isLoadMore })

  useEffect(() => fetchData(activeTab), [activeTab])

  function fetchData(params) {
    switch (params) {
      case 0:
        fetchOrders()
        break
      default:
        setLoading(false)
        break
    }
  }

  async function fetchOrders() {
    if (orderPage === 0) return

    try {
      //fetch orders
      const res = await fetch(
        `/.netlify/functions/bigcommerce?endpoint=orders&page=${orderPage}`,
        {
          credentials: "same-origin",
          mode: "same-origin",
        }
      )

      if (res.status === 200) {
        const response = await res.json()
        const new_response = response.filter(
          el => el.custom_status !== "Incomplete"
        )

        //fetch products per order
        let items = []
        for (let i = 0; i < new_response.length; i++) {
          let item = new_response[i]

          const res = await fetch(
            `/.netlify/functions/bigcommerce?endpoint=/v2${item.products.resource}`,
            {
              credentials: "same-origin",
              mode: "same-origin",
            }
          )

          if (res.status === 200) {
            const itemInfo = await res.json()
            item.products.info = itemInfo

            items.push(item)
          }
        }

        setOrders(items)

        //hide load more button
        if (response.length < 250) {
          setPage(0)
        }
      } else {
        setPage(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
      setIsLoadMore(false)
    }
  }

  function renderTab() {
    switch (activeTab) {
      case 0:
        return <OrdersTab orders={orders} />
      case 1:
        return <AddressTab {...value} />
      case 2:
        return <SettingsTab {...value} />
      default:
        break
    }
  }

  const tabs = ["Orders", "Address", "Account Settings"]

  return (
    <div
      className="container"
      style={{ marginTop: "5rem", marginBottom: "4rem" }}
    >
      <ul class="nav justify-content-center">
        {tabs.map((tab, i) => (
          <li class="nav-item" key={i}>
            <button
              className={`btn btn-link ${activeTab !== i && "text-dark"}`}
              onClick={() => {
                setActiveTab(i)
                setPage(1)
                if (i !== 2) setLoading(true)
              }}
            >
              {tab}
            </button>
          </li>
        ))}
      </ul>
      <hr />

      {isLoading ? (
        <center>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </center>
      ) : (
        renderTab()
      )}
    </div>
  )
}

export default Account
